export enum ActivityType {
    timesheetRecord = 69859,
    comment = 70048,
}